import React, { useState, useEffect, useCallback } from 'react';
import { AnimatePresence } from 'framer-motion';
import ToastNotification from './ToastNotification';
import { useNotifications } from 'hooks/useNotifications';
import { useAuth } from 'contexts/AuthContext';

const NotificationManager = () => {
  const { user, profile } = useAuth();
  const userRole = profile?.is_admin ? 'admin' : profile?.is_writer ? 'writer' : profile?.is_qa ? 'qa' : 'client';
  const { notifications, markAsRead } = useNotifications(user?.uid, userRole);
  const [activeToasts, setActiveToasts] = useState([]);
  const [lastNotificationCount, setLastNotificationCount] = useState(0);

  // Handle new notifications
  useEffect(() => {
    if (notifications.length > lastNotificationCount) {
      const newNotifications = notifications.slice(0, notifications.length - lastNotificationCount);
      
      newNotifications.forEach((notification, index) => {
        // Only show toast for unread notifications
        if (!notification.read_by?.includes(user?.uid)) {
          setTimeout(() => {
            showToast(notification);
          }, index * 200); // Stagger notifications
        }
      });
    }
    
    setLastNotificationCount(notifications.length);
  }, [notifications, lastNotificationCount, user?.uid]);

  const showToast = (notification) => {
    const toastId = `toast-${notification.id}-${Date.now()}`;
    
    setActiveToasts(prev => [...prev, {
      id: toastId,
      notification: notification,
      timestamp: Date.now()
    }]);

    // Auto-remove after 8 seconds if not interacted with
    setTimeout(() => {
      removeToast(toastId);
    }, 8000);
  };

  const removeToast = (toastId) => {
    setActiveToasts(prev => prev.filter(toast => toast.id !== toastId));
  };

  const handleReply = useCallback((notification) => {
    // Navigate to the item and focus reply input
    console.log('Reply to notification:', notification);
    // You can add navigation logic here
  }, []);

  const handleView = useCallback((notification) => {
    // Navigate to the item
    console.log('View notification:', notification);
    // You can add navigation logic here
  }, []);

  const handleMarkAsRead = useCallback(async (notificationId) => {
    try {
      await markAsRead(notificationId);
    } catch (error) {
      console.error('Error marking notification as read:', error);
    }
  }, [markAsRead]);

  return (
    <div className="notification-manager">
      <AnimatePresence>
        {activeToasts.map((toast, index) => (
          <div 
            key={toast.id}
            style={{ 
              transform: `translateY(${index * 110}px)`,
              zIndex: 1000 - index 
            }}
          >
            <ToastNotification
              notification={toast.notification}
              onClose={() => removeToast(toast.id)}
              onReply={handleReply}
              onView={handleView}
              onMarkAsRead={handleMarkAsRead}
              position="top-right"
            />
          </div>
        ))}
      </AnimatePresence>
    </div>
  );
};

export default NotificationManager;